module.exports = __webpack_public_path__ + "static/media/light_en.072f5b63.svg";